module.exports = __webpack_public_path__ + "img/modulo-1.3685db04.svg";